export default __webpack_public_path__ + "static/media/pelanggan.7cf958c3.svg";